module.exports = __webpack_public_path__ + "media/misc/grunge-base-01df575f.png";